import React from 'react';
import { Link } from 'react-router-dom';
import { firestore } from '../../firebase/firebase.utils'
import Logo from '../Logo/Logo'
class Rank extends React.Component {
  constructor(){
    super()
    this.state = {
      text: '',
      link: '',
      text2: ''
    }
    this.onEmailChange = this.onEmailChange.bind(this);
  }
  update = (e) => {
    e.preventDefault()
    firestore.collection("home").doc("Yf3RJ3bvBUKVpU9rToPp").set({
      text: this.state.text,
      link: this.state.link,
      text2: this.state.text2
  })
  .then(function(docRef) {
      console.log("Document written with ID: ", docRef.id);
  })
  .catch(function(error) {
      console.error("Error adding document: ", error);
  });
  }
  componentDidMount(){
    const that = this;
    firestore.collection("home").doc("Yf3RJ3bvBUKVpU9rToPp")
    .get()
    .then(function(doc) {
          const d = doc.data()
          that.setState({text:d.text,link:d.link,text2:d.text2})
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });

  }
  onEmailChange(event){
      const {value,name} = event.target;
      this.setState({...this.state,[name]: value})
  }
  render(){
    const { name, entries,showSearch,showHistory } = this.props
    const{text,text2,link} = this.state
  return (
    <div>
      <Logo/>
      <div className='white f3'>
        {`${name}, your current points are...`}
      </div>
      <div className='white f1'>
        {entries}
      </div>
      <div className='white f3'>
     {this.state.text}<a href={this.state.link} rel="noopener noreferrer" target="_blank" className="link green">Here</a>
      </div>
      <div className='white f3'>
      {this.state.text2}
      </div>
      <div className='form center pa4 br3 shadow-5'>
        <button
            className='grow f3 f5-ns link ph3 pv2 white bg-near-black'
            onClick={()=>showSearch()}
          >Transfer or Request Points</button>
          <button
            className='grow f3 f5-ns link ph3 pv2 white bg-near-black'
            onClick={()=>showHistory()}
          >Transaction History</button>
          {/* <button className='grow f3 f5-ns link ph3 pv2 white bg-near-black'>
            <Link to="/requests" className="white no-underline hover-white">Points Requests</Link>
          </button> */}
          <button className='grow f3 f5-ns link ph3 pv2 white bg-near-black'>
            <Link to="/redeempoints" className="white no-underline hover-white">Redeem Points</Link>
          </button>
      </div>
      {
      this.props.currentUser === "vqpoint@hotmail.com"
      ? <form onSubmit={this.update}>
         <input
          className="pa2 input-reset white ba bg-transparent hover-bg-black hover-white w-100"
          type="text"
          name="text"
          value={text}
          onChange={this.onEmailChange}
        />
         <input
          className="pa2 input-reset white ba bg-transparent hover-bg-black hover-white w-100"
          type="text"
          name="link"
          value={link}
          onChange={this.onEmailChange}
        />
         <input
          className="pa2 input-reset white ba bg-transparent hover-bg-black hover-white w-100"
          type="text"
          name="text2"
          value={text2}
          onChange={this.onEmailChange}
        />
        <button type="submit">Update</button>
      </form>
      :<div></div>
      }
    </div>
  );
  }
}

export default Rank;